module.exports = __webpack_public_path__ + "img/phonelink_erase.ef75460b.svg";